<div class="relative">
    <div id="logo_box" class="flex items-center justify-center sticky top-0 h-[70px] inset-x-0">
        <img src="../../../../assets/img/sige.png" alt="SIGE" class="h-[22px] w-auto mr-2">
        <span class="text-white text-2xl font-semibold">SIGE</span>
    </div>
    <mat-nav-list>
        <ng-container *ngFor="let item of menuItems">
            <a mat-list-item [routerLink]="item.route" routerLinkActive="active-link" *ngIf="item.canView$ | async">
                <mat-icon matListItemIcon class="justify-center items-center">{{item.icon}}</mat-icon>
                <span class="text-[15px]">{{item.label}}</span>
            </a>
        </ng-container>
    </mat-nav-list>
</div>